import React from "react";
import "../CSS/Contact.css"

const Contact = () => {
    return(
        <div>
            <h1>Contact</h1>
            <h2>Email</h2>
            <h2 className="email">contact@davidlaraarango.com</h2>
            <a className= "LK-link" href="https://www.linkedin.com/in/david-lara-arango-ph-d-422a78ba"><h3 className="linkedInprofile">LinkedIn profile</h3></a>
        </div>
    )
}

export default Contact;


// WEBPACK FOOTER //
// ./src/Components/Contact.js